import { useContext } from 'react';
import toast from 'react-hot-toast';
import { startOfMonth } from 'date-fns';
import { showConfirmBox } from '../../../components/ConfirmBox';
import { ProgressContext, UserContext } from '../../../contexts';
import { saveReportData, submitReportData, getReportMxData } from '../../../data/mysql';
import { useMonthlyReportStore } from '../../../store/reportStore';
import { initCalendar } from '../../../utils/calendar';
import { getFormattedTime, openNewTab } from '../../../utils/common';

const ReportBaseInfo = () => {
  const { reportMxData, reportDxData, selectedMonth, setReportDxData, setReportMxData } = useMonthlyReportStore();
  const { spinner } = useContext(ProgressContext);
  const { user } = useContext(UserContext);
  const disabledMassage = reportMxData.c_id ? '' : '등록된 교회가 없습니다. 합회에 문의해주세요'; // 교회 id가 없으면

  /**
   * 보고서를 제출한다.
   * 1. 보고서 제출
   * 2. 제출 성공후 UI 업데이트(최신 데이터)
   * 3. 성공 토스트
   */
  const handleSendButtonClick = async () => {
    try {
      spinner.start();
      const result = await submitReportData({ reportId: reportMxData.id, reportMxData, reportDxData });

      result && // 제출 성공후 UI 업데이트(최신 데이터)
        setReportMxData(
          await getReportMxData({
            userId: user.id,
            dt: Math.floor(startOfMonth(selectedMonth).getTime() / 1000),
          }),
        );
      toast.success('제출 되었습니다.');
    } catch (e) {
      console.error(e);
      toast.error('제출에 실패하였습니다.');
    } finally {
      spinner.stop();
    }
  };

  /**
   * 보고서를 다시 작성한다.
   * : 참고로 이건 달력 데이터만 초기화 한다.
   */
  const handleResetButtonClick = async () => {
    try {
      spinner.start();
      setReportDxData(initCalendar(selectedMonth, new Date()));
      toast.success('다시 작성 되었습니다.');
    } catch (e) {
      console.error(e);
      toast.error('다시 작성에 실패하였습니다.');
    } finally {
      spinner.stop();
    }
  };

  /**
   * 월(月) 데이터를 임시로 저장한다.
   */
  const handleSaveButtonClick = async () => {
    try {
      spinner.start();
      const result = await saveReportData({ reportId: reportMxData.id, dxData: reportDxData, mxData: reportMxData });
      result && toast.success('저장 되었습니다.');
    } catch (e) {
      console.error(e);
    } finally {
      spinner.stop();
    }
  };

  const defaultSubmitTime = Math.floor(new Date().getTime() / 1000);

  return (
    <div className="row" style={{ marginBottom: 10 }}>
      <div className="panel">
        <div className="panel-heading">
          <h3>
            {reportMxData?.church_name || ''}({reportMxData?.pastor_name || ''})
          </h3>
        </div>
        {disabledMassage ? (
          <div className="panel-body">
            <div style={{ color: '#FF4500', marginLeft: 15, fontSize: '1.3em' }}>{disabledMassage}</div>
          </div>
        ) : (
          <div className="panel-body">
            {reportMxData?.is_submitted === 'N' ? (
              <>
                <div className="col-xs-12 col-sm-4 col-md-4">
                  <button
                    className="styled-button send" //
                    onClick={() =>
                      showConfirmBox(
                        //
                        '보고서를 제출할까요?',
                        '보고서가 제출되면 다시 수정하실 수 없습니다.',
                        handleSendButtonClick,
                        'styled-button send',
                      )
                    }
                  >
                    보고서 제출
                  </button>
                </div>
                <div className="col-xs-6 col-sm-4 col-md-4">
                  <button //
                    className="styled-button reset"
                    onClick={() =>
                      showConfirmBox(
                        //
                        '다시 작성할까요?',
                        '등록된 데이터가 삭제됩니다. 그래도 다시 작성하시겠습니까?',
                        handleResetButtonClick,
                        'styled-button reset',
                      )
                    }
                  >
                    다시 작성
                  </button>
                </div>
                <div className="col-xs-6 col-sm-4 col-md-4">
                  <button //
                    className="styled-button save"
                    onClick={handleSaveButtonClick}
                  >
                    저장
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="col-xs-12 col-sm-8 col-md-8">
                  <span className="message">해당 보고서는 {getFormattedTime(reportMxData.submitted_at === 0 ? defaultSubmitTime : reportMxData.submitted_at)}에 제출 되었습니다.</span>
                </div>
                <div className="col-xs-6 col-sm-2 col-md-2">
                  <button //
                    className="styled-button download"
                    onClick={() => openNewTab(`/printReport/${reportMxData?.id}/download`)}
                  >
                    다운로드
                  </button>
                </div>
                <div className="col-xs-6 col-sm-2 col-md-2">
                  <button //
                    className="styled-button print"
                    onClick={() => openNewTab(`/printReport/${reportMxData?.id}/print`)}
                  >
                    인쇄
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportBaseInfo;
